export function isAllowedHostname(hostname: string): boolean {
  return LOGIN_SERVICE_DOMAINS.some(domain => hostname.endsWith(domain));
}

export function parseUrl(url: string): URL | null {
  try {
    return new URL(decodeURIComponent(url));
  } catch {
    return null;
  }
}
